<template>
  <div ref="containerRef" class="footer">
    <FormCheckbox
        v-if="multiple && (isStatic || isSelect)"
        :disabled="!initialLoad"
        v-model="selected"
        :label="$t('front.select_all')"
        @change="emit('select', selected)"
        @deselect="emit('select', selected)"
    />

    <Button v-if="request.select"
            class="btn-primary btn-bordered ms-auto"
            @click="emit('apply')"
    >
      {{ $t('global.close') }}
    </Button>

    <template v-else>
      <Button class="ms-auto me-2" @click="emit('cancel')">
        {{ $t('global.cancel') }}
      </Button>
      <Button class="btn-primary btn-bordered" @click="emit('apply')">
        {{ $t('global.apply') }}
      </Button>
    </template>
  </div>
</template>
<script setup>
import FormCheckbox from "@/js/Elements/Form/FormCheckbox.vue";
import Button from "@/js/Elements/Button.vue";
import {ref, watch} from "vue";

const emit = defineEmits(['select', 'apply', 'cancel'])
const props = defineProps({
  multiple: Boolean,
  allSelected: Number,
  isStatic: Boolean,
  request: Object,
  isSelect: Boolean,
  loading: Boolean,
  initialLoad: Boolean,
});
const containerRef = ref();
const selected = ref(props.allSelected);

watch(() => props.allSelected, (value) => selected.value = value);

defineExpose({
  getContainer() {
    return containerRef.value;
  }
})
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";
.footer {
  display: flex;
  align-items: center;
  padding: spacing(3);
  border-top: themeColor('border') solid toRem(1);

  :deep(.form-check) {
    overflow: hidden;
    margin-left: spacing(2);

    .form-check-label {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>